import i18n from "../i18n";
import * as Yup from "yup";

export const createIssuanceOfEntryStickerForParkingSchema = (isAttachments: {
  haveEmployeeCard: number;
  haveNationalId: number;
}) => {
  return Yup.object({
    name: Yup.string().required(
      i18n.language === "en"
        ? "Name is required."
        : "الاسم مطلوب."
    ),

    department: Yup.string().required(
      i18n.language === "en"
        ? "Department is required."
        : "القسم مطلوب."
    ),

    jobTitle: Yup.string().required(
      i18n.language === "en"
        ? "Job title is required."
        : "المسمى الوظيفي مطلوب."
    ),

    mobileNo: Yup.string()
      .required(
        i18n.language === "en"
          ? "Mobile number is required."
          : "رقم الجوال مطلوب."
      )
      .matches(
        /^\d{1,14}$/,
        i18n.language === "en" ? "Enter a valid number." : "أدخل رقمًا صالحًا."
      ),

    officePhoneNo: Yup.string()
      .required(
        i18n.language === "en"
          ? "Office phone number is required."
          : "رقم الهاتف المكتبي مطلوب."
      )
      .matches(
        /^\d{1,14}$/,
        i18n.language === "en" ? "Enter a valid number." : "أدخل رقمًا صالحًا."
      ),

    employeeNumber: Yup.string().required(
      i18n.language === "en"
        ? "Employee number is required."
        : "رقم الموظف مطلوب."
    ),

    uploadEmployeeCard: Yup.mixed().when([], {
      is: () => isAttachments.haveEmployeeCard,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Employee card is required."
            : "بطاقة هوية الموظف مطلوبة."
        ),
    }),

    uploadNationalId: Yup.mixed().when([], {
      is: () => isAttachments.haveNationalId,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "National ID is required."
            : "رقم الهوية الوطنية مطلوب."
        ),
    }),
  });
}
